module.exports = __webpack_public_path__ + "img/Itunes-logo-button.128ae409.png";